/* eslint-disable no-unused-vars */
import React, { useImperativeHandle, useState } from 'react';
import Modal from '../index';
import style from './croppModal.module.scss';
import CropperConnector from 'components/modal/croppModal/cropperConnector';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import Button from 'controls/buttons/submit';

export type CropperRef = {
  open: (file: File) => void;
};

type CropperProps = {
  cropperConnector: CropperConnector;
  replaceFile: (oldF: File | undefined, newF: Blob) => void;
  initialAspectRatio?: number;
};

const CropperComponent = React.forwardRef<CropperRef, CropperProps>(
  ({ cropperConnector, replaceFile, initialAspectRatio = NaN }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [image, setImage] = useState<string>('');
    const [cropper, setCropper] = useState<Cropper>();
    const [file, setFile] = useState<File>();

    useImperativeHandle(ref, () => ({
      open: (file: File) => {
        setFile(file);
        setIsOpen(true);
        const reader = new FileReader();
        reader.onload = () => {
          setImage(reader.result as string);
        };

        reader.readAsDataURL(file);
      },
    }));

    const onClose = () => {
      setIsOpen(false);
      cropperConnector.onclose();
    };

    return (
      <Modal open={isOpen} onClose={onClose}>
        <div className={style.container}>
          <Cropper
            style={{ height: 400, width: '100%' }}
            initialAspectRatio={initialAspectRatio}
            src={image}
            viewMode={1}
            minCropBoxHeight={50}
            minCropBoxWidth={50}
            background={false}
            responsive={true}
            autoCropArea={1}
            checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
            onInitialized={(instance) => {
              setCropper(instance);
            }}
            guides={true}
          />
          <div className={style.buttons}>
            <Button
              className={style.close}
              onClick={() => {
                if (typeof cropper !== 'undefined') {
                  cropper.getCroppedCanvas().toBlob((blob) => {
                    if (blob) {
                      replaceFile(file, blob);
                      setIsOpen(false);
                    }
                  });
                }
              }}
            >
              Применить
            </Button>
            <Button className={'btn-cancel'} onClick={onClose}>
              Отмена
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
);
CropperComponent.displayName = 'CropperComponent';

export default CropperComponent;
